// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22V2H2V22H22ZM6 7H8V12.7188L11.4424 7.50293H12.8193L13.8623 12.7119L15.9551 7.8877L16.0508 7.64062L16.2979 7H18.541L17.7998 8.66113L14.1836 16.9971H12.6807L11.4912 11.0586L7.57324 16.9971H6V7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-iwiki-filled')
export default class LogoIwikiFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-iwiki-filled',
    }
  }
}
